import React, { PropTypes } from 'react';
import classnames from 'classnames';

class Input extends React.Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    this.props.onChange(e.target.value);
  }

  render() {

    const {
      value,
      label,
      type,
      className,
      placeholder,
    } = this.props;

    return (
      <div className={classnames('row', className)}>
        <div className='col-xs-12'>
          <input className='form-control' type={type} value={value} onChange={this.onChange} placeholder={placeholder} />
        </div>
      </div>
    );
  }
}

export default Input;



// WEBPACK FOOTER //
// ./src/components/UI/Form/Fields/Input.js